import { Phone } from "lucide-react";
import { SITE } from "../lib/site";

export default function StickyMobileCTA() {
  return (
    <a
      href={SITE.phoneHref}
      data-testid="sticky-mobile-call"
      className="md:hidden fixed bottom-0 left-0 right-0 z-50 flex items-center justify-center gap-3 py-4 font-bold uppercase tracking-[0.18em] text-sm"
      style={{
        backgroundColor: "var(--gold)",
        color: "#0A0A0A",
        boxShadow: "0 -4px 20px rgba(197,160,89,0.3)",
      }}
    >
      <Phone size={18} /> Call {SITE.phone}
    </a>
  );
}
